<template>
  <div>
    <topBar :fuzzy="fuzzy" currPage="worker"></topBar>
    <div v-if="isloading">
      <loading></loading>
    </div>
    <div class="m-content" v-else>
      <div class="m-content-info">
        <div class="m-comwid m-tjanli" v-if="detailInfo">
          <div
            class="m-back"
            v-if="workerCaseList && workerCaseList.length > 0"
          >
            <img
              v-if="workerCaseList[0].cover"
              :src="workerCaseList[0].cover | imgcrop(1200, 300)"
            />
            <img
              v-else
              :src="(NEWIMAGE + 'nocaseimage.png') | imgcrop(1200, 300)"
            />
          </div>
          <div class="m-back" v-else>
            <img :src="(NEWIMAGE + 'nocaseimage.png') | imgcrop(1200, 300)" />
          </div>
          <div class="m-backinfo">
            <div v-if="workerCaseList && workerCaseList.length > 0">
              <template v-if="detailInfo.vocation == '策划师'">
                <p class="m-title">{{ workerCaseList[0].theme }}</p>
                <p v-if="workerCaseList[0].weddingId">
                  <a
                    target="_blank"
                    @click="logger($event, +workerCaseList[0].number)"
                    :href="
                      CURRENT_URL2 +
                      'case/detail.html?type=0&caseNum=' +
                      workerCaseList[0].number
                    "
                    >查看案例</a
                  >
                </p>
                <p v-else>
                  <a
                    target="_blank"
                    @click="logger($event, workerCaseList[0].number)"
                    :href="
                      CURRENT_URL2 +
                      'case/detail.html?type=1&caseNum=' +
                      workerCaseList[0].number
                    "
                    >查看案例</a
                  >
                </p>
              </template>
              <template v-else>
                <p class="m-title" v-if="workerCaseList[0].weddingId">
                  {{ workerCaseList[0].hotel }}
                </p>
                <p class="m-title" v-else>{{ workerCaseList[0].theme }}</p>
                <p>
                  <a
                    target="_blank"
                    @click="logger($event, workerCaseList[0].number)"
                    :href="
                      CURRENT_URL2 +
                      'case/detail.html?type=1&caseNum=' +
                      workerCaseList[0].number
                    "
                    >查看案例</a
                  >
                </p>
              </template>
            </div>
            <div v-else="">
              <p class="m-title">&nbsp;</p>
              <p style="height: 30px"></p>
            </div>
            <div class="m-bottom">
              <ul>
                <li>
                  <p>预定量</p>
                  <p>{{ detailInfo.orderNum }}</p>
                </li>
                <li>
                  <p>好评率</p>
                  <p v-if="detailInfo.commontNum == 0">0<i>%</i></p>
                  <p v-else>
                    {{
                      Math.ceil(
                        detailInfo.goodCommontNum / detailInfo.commontNum
                      ) * 100
                    }}<i>%</i>
                  </p>
                </li>
                <li style="margin-top: 5px">
                  <p>
                    <img
                      @click="setPopVis(0)"
                      v-if="detailInfo.avator"
                      :src="detailInfo.avator | imgcrop(80, 80)"
                    />
                    <img
                      @click="setPopVis(0)"
                      :src="IMAGE_URL + '/header_432.png'"
                      v-else
                    />
                  </p>
                </li>
                <li>
                  <p>评论</p>
                  <p>{{ detailInfo.commontNum }}</p>
                </li>
                <li>
                  <p>
                    价格
                    <i
                      class="m-youhui"
                      v-if="
                        detailInfo.activityServiceList &&
                        detailInfo.activityServiceList.length > 0
                      "
                    >
                      <span class="m-youhui-info">
                        在找我婚礼预定<template
                          v-for="(activi, m) in detailInfo.activityServiceList"
                        >
                          <template
                            v-if="
                              detailInfo.activityServiceList.length > 1 &&
                              m < detailInfo.activityServiceList.length - 1
                            "
                            >{{ activi }}、</template
                          >
                          <template v-else>{{ activi }}</template> </template
                        >，可享受平台补贴哦<i></i
                      ></span>
                    </i>
                  </p>
                  <p>{{ detailInfo.minServiceAmount / 100 }}<i>起</i></p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="m-comwid m-useinfo" v-if="detailInfo">
          <p class="f-rank">
            <a>
              <rank
                :votype="detailInfo.vocation"
                :rankvalue="detailInfo.levelScore"
              ></rank>
            </a>
          </p>
          <p class="m-name">
            {{ detailInfo.name }}<a>{{ detailInfo.vocation }}</a>
          </p>
          <p><a class="m-btn" @click="setShow(1)">服务以及费用</a></p>
          <p class="m-qhbutton" v-if="othShow">
            <a class="m-sub" @click="setShow(0)"></a>
          </p>
        </div>
        <collapseTransition name="mybox">
          <div class="m-clear m-serinfo" v-show="othShow">
            <div class="m-comwid m-ser-info">
              <div class="m-ser-type">
                <p>服务类型</p>
                <ul
                  v-if="
                    detailInfo.serviceList && detailInfo.serviceList.length > 0
                  "
                >
                  <template v-for="(list, ind) in detailInfo.serviceList">
                    <li
                      :class="{ 'm-active': ind == serIndex }"
                      @click="setSer(ind)"
                    >
                      <p>
                        <i
                          v-if="list.type && list.type == 'MAJOR'"
                          class="zhutui"
                        ></i
                        >{{ list.serviceName }}
                      </p>
                      <div
                        class="m-pri m-pri-ori"
                        v-if="
                          list.activityAmount <= 0 ||
                          list.displayAmount == list.activityAmount
                        "
                      >
                        <p>¥{{ list.displayAmount / 100 }}</p>
                      </div>
                      <div class="m-pri" v-else>
                        <p>原价</p>
                        <p>¥{{ list.displayAmount / 100 }}</p>
                        <div class="m-tuangou">
                          <p>立享价</p>
                          <p>¥{{ list.activityAmount / 100 }}</p>
                        </div>
                      </div>
                      <div class="pri-desc" v-if="list.serviceMemo">
                        <i></i>{{ list.serviceMemo }}
                      </div>
                    </li>
                  </template>
                </ul>
              </div>
              <div class="m-ser-she">
                <p>服务档期</p>
                <workSche :workerId="wid"></workSche>
                <p>
                  <a
                    class="m-concat"
                    target="_blank"
                    href="https://eco-api.meiqia.com/dist/standalone.html?eid=3&amp;groupid=56a3ccf2d587e9b85257a51a1a8890c3"
                    >联 系 TA</a
                  >
                </p>
              </div>
              <div class="m-prov">
                <p style="text-align: left">服务区域</p>
                <ul class="m-prov" v-if="detailInfo.cityListMap">
                  <template
                    v-for="(city, key, index) in detailInfo.cityListMap"
                  >
                    <li>
                      {{ key }}<i></i>
                      <p class="m-sercity" :class="{ 'm-last': index == 2 }">
                        <template v-for="(list, index) in city">
                          <span>{{ list.cityName }}</span>
                        </template>
                      </p>
                    </li>
                  </template>
                </ul>
              </div>
            </div>
          </div>
        </collapseTransition>

        <div
          class="m-clear m-comwid m-caseinfo"
          v-if="detailInfo && workerCaseList && workerCaseList.length > 1"
        >
          <h3><span>真实婚礼案例</span></h3>
          <div class="m-biaozhi">
            <template
              v-for="(item, index) in workerCaseList"
              v-if="index == 1 || index == 2"
            >
              <div class="m-bzlist" :class="{ 'm-bzlist-last': index == 2 }">
                <a target="_blank">
                  <img
                    v-if="item.cover"
                    :src="item.cover | imgcrop(590, 214)"
                  />
                  <img
                    v-else
                    :src="(NEWIMAGE + 'nocaseimage.png') | imgcrop(590, 214)"
                  />
                </a>
                <div
                  class="m-bzinfo"
                  @click="openCase(item, detailInfo.vocation, $event)"
                >
                  <div class="m-cell">
                    <template v-if="item.weddingId">
                      <p class="m-themt" v-if="detailInfo.vocation == '策划师'">
                        {{ item.theme }}
                      </p>
                      <p class="m-themt" v-else>{{ item.hotel }}</p>
                      <p v-if="detailInfo.vocation == '策划师' && item.price">
                        ¥{{ item.price / 100 }}
                      </p>
                      <p v-else>
                        {{ formateData(item.weddingDate, "YYYY-MM-DD") }}
                      </p>
                    </template>
                    <template v-else>
                      <p class="m-themt">{{ item.theme }}</p>
                    </template>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div
            class="m-caselist"
            v-if="detailInfo && workerCaseList && workerCaseList.length > 3"
          >
            <template v-for="(item, index) in workerCaseList" v-if="index > 2">
              <collapseTransition name="mybox">
                <div
                  class="m-listinfo"
                  @click="openCase(item, detailInfo.vocation, $event)"
                  :class="{ 'm-last': (index - 3) % 4 == 3 }"
                  v-show="index < num"
                >
                  <a class="m-fm">
                    <img
                      v-if="item.cover"
                      :src="item.cover | imgcrop(285, 175)"
                    />
                    <img
                      v-else
                      :src="(NEWIMAGE + 'nocaseimage.png') | imgcrop(285, 175)"
                    />
                  </a>
                  <template v-if="item.weddingId">
                    <p>
                      <a>{{ item.hotel }}</a>
                    </p>
                    <p v-if="detailInfo.vocation == '策划师'">
                      ¥{{ item.price / 100 }}
                    </p>
                    <p v-else>
                      {{ formateData(item.weddingDate, "YYYY-MM-DD") }}
                    </p>
                  </template>
                  <template v-else>
                    <p style="margin-top: 14px">
                      <a>{{ item.theme }}</a>
                    </p>
                  </template>
                </div>
              </collapseTransition>
            </template>

            <p
              class="m-jiazai"
              v-if="detailInfo && workerCaseList && workerCaseList.length > 7"
            >
              <a @click="setNum(10000)" v-show="num <= 7">加载更多</a>
              <a @click="setNum(7)" v-show="num > 7">收起</a>
            </p>
          </div>
        </div>
        <!--新增作品-->
        <div class="m-clear m-comwid m-zuopin" v-if="productionList.length > 0">
          <h3><span style="left: 145px">作品</span></h3>
          <div class="m-zuopinlist">
            <template v-for="(item, index) in productionList">
              <div
                class="m-zuopininfo"
                :id="'zuopin' + index"
                :class="{ last: index % 4 == 3 }"
                v-show="index >= start && index < end"
              >
                <a class="m-fm" @click="openWorkItem(item, index)">
                  <img
                    v-if="item.cover"
                    :src="item.cover | imgcrop(285, 175)"
                    alt="查看详情"
                  />
                  <img
                    width="285"
                    height="175"
                    src="https://image.izhaowo.com/www2/images/examples/pic239x179.jpg"
                    v-else
                  />
                </a>
                <a
                  class="m-spbofan"
                  @click="openWorkItem(item, index)"
                  v-if="item.medias && item.medias.length > 0"
                ></a>
                <p>{{ item.theme }}</p>
              </div>
            </template>
            <a
              class="m-zpbtn m-zpbtn-prev"
              id="m-zpbtn-prev"
              @click="lunbo(0)"
              v-show="start > 0"
            ></a>
            <a
              class="m-zpbtn m-zpbtn-next"
              id="m-zpbtn-next"
              @click="lunbo(1)"
              v-show="end < productionList.length"
            ></a>
          </div>
        </div>

        <!--预定记录-->
        <workOrder :workerId="wid"></workOrder>
        <workCom
          :workerId="wid"
          :vocation="detailInfo.vocation"
          :usrname="detailInfo.name"
        ></workCom>
      </div>
    </div>
    <footerBar></footerBar>
    <openVideo v-if="videoVisible" :videoKey="videoKey"></openVideo>
    <openYunVideo
      v-if="yunVisible"
      @closeYun="closeYUN"
      :url="yunURL"
    ></openYunVideo>
    <div class="m-popup-layer" id="userPopup" v-if="popVisable">
      <table class="m-popup-table">
        <tbody>
          <tr>
            <td>
              <div class="m-popup-content m-popupinfo">
                <div class="m-popup-title">
                  <a
                    href="javascript:void(0);"
                    class="m-close"
                    @click="setPopVis(1)"
                  ></a>
                </div>
                <div class="m-popup-center m-prop-center">
                  <p class="m-pic m-pichead">
                    <img
                      v-if="detailInfo.avator"
                      :src="detailInfo.avator | imgcrop(80, 80)"
                    />
                    <img :src="IMAGE_URL + '/header_432.png'" v-else />
                  </p>
                  <p class="m-name">
                    {{ detailInfo.vocation }}-{{ detailInfo.name }}
                  </p>
                  <p class="m-usinfo">
                    <span class="m-uself"
                      >性别：{{ getSex(detailInfo.sex) }}</span
                    ><span>年龄：{{ detailInfo.age }}</span>
                  </p>
                  <p class="m-usinfo">
                    <span class="m-uself">身高：{{ detailInfo.height }}cm</span
                    ><span>星座：{{ detailInfo.constellation }}</span>
                  </p>
                  <p class="m-usinfo" style="text-align: left">
                    {{ detailInfo.profile }}
                  </p>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import footerBar from "../common/foot-bar.vue";
import topBar from "../common/top-bar.vue";
import loading from "../common/loading.vue";
import tipDialog from "../common/tip-dialog.vue";
import api from "../../config/api.js";
import utils from "../../plugin/utils.js";
import workCom from "./_worker_comment.vue";
import workOrder from "./_worker_order.vue";
import workSche from "./_worker_sche.vue";
import rank from "../common/_rank.vue";
import dayjs from "dayjs";
import collapseTransition from "../common/collapseTransition.vue";
import { imgcrop } from "../../plugin/imgcrop";
import openVideo from "../common/openVideo.vue";
import openYunVideo from "../common/openYunVideo.vue";
import Logger from "../../plugin/logger.js";
export default {
  name: "worker",
  data: function () {
    return {
      isloading: true,
      IMAGE_URL: api.IMAGE_URL,
      NEWIMAGE: api.host,
      fuzzy: "",
      workerCaseList: [],
      productionList: [],
      wid: utils.getUrlKey("wid"),
      detailInfo: "",
      CURRENT_URL2: api.CURRENT_URL2,
      num: 7,
      popVisable: false,
      serIndex: 0,
      othShow: false,
      start: 0,
      end: 4,
      videoKey: "",
      videoVisible: false,
      yunVisible: false,
      yunURL: "",
    };
  },
  created: function () {
    let vm = this;
    vm.getDetailInfo();
    vm.bus.$on("closevideo", function (obj) {
      vm.videoVisible = false;
    });
  },
  components: {
    footerBar,
    topBar,
    loading,
    workCom,
    workOrder,
    workSche,
    rank,
    collapseTransition,
    openVideo,
    openYunVideo,
  },
  methods: {
    lunbo: function (type) {
      if (type == 0) {
        //左
        this.start = this.start - 4;
        this.end = this.end - 4;
      } else {
        //右
        this.start = this.start + 4;
        this.end = this.end + 4;
      }
    },
    closeYUN: function () {
      this.yunVisible = false;
    },
    openWorkItem: function (item, index) {
      //打开作品 可能是图片也可能是相册
      let vm = this;
      if (item.medias && item.medias.length > 0) {
        //说明是视频 需要判断是优酷视频还是阿里云视频
        if (item.medias[0].itemKey) {
          vm.videoKey = item.medias[0].itemKey;
          vm.videoVisible = true;
          vm.yunVisible = false;
        } else {
          //说明是阿里云视频
          vm.videoVisible = false;
          vm.yunURL = item.medias[0].url;
          vm.yunVisible = true;
        }
      } else {
        let imgHref = "";
        let img = "";
        let m = "";
        let m2 = "";
        if (item.images) {
          $.each(item.images, function (index, content) {
            m = imgcrop(content.url, "1920", "auto", 0);
            m2 = imgcrop(content.url, "80", "80", 0);
            imgHref +=
              "{src:" +
              "'" +
              m +
              "',thumb:" +
              "'" +
              m2 +
              "',downloadUrl:false},";
          });
          let newImg = imgHref.substring(0, imgHref.length - 1);
          img = eval("[" + newImg + "]");
          lightbox(0, img, "zuopin" + index);
        }
      }
    },
    setShow: function (type) {
      if (type == 1) {
        this.othShow = true;
      } else {
        this.othShow = false;
      }
    },
    setSer: function (ind) {
      this.serIndex = ind;
    },
    openCase: function (item, type, $event) {
      let ctype = 0;
      if (type != "策划师" || !item.weddingId) {
        ctype = 1;
      }
      window.open(
        this.CURRENT_URL2 +
          "case/detail.html?type=" +
          ctype +
          "&caseNum=" +
          item.number
      );
      this.logger($event, item.number);
    },
    logger($event, number) {
      const logger =
        api.API_URL.indexOf("webapi.izhaowo.com") == -1
          ? Logger.useDev()
          : Logger.useRel();
      logger.logTapCase({
        evt: $event,
        caseId: number,
        userId: this.cookie.get("usr-id"),
      });
    },
    setNum: function (num) {
      this.num = num;
    },
    getSex: function (sex) {
      if (sex == "FEMALE") return "女";
      return "男";
    },
    setPopVis: function (type) {
      if (type == 1) {
        this.popVisable = false;
      } else {
        this.popVisable = true;
      }
    },
    getDetailInfo: function () {
      let vm = this;
      let url = api.API_URL + "worker/v1/query/detail";
      vm.getNewAjax(
        url,
        { workerId: vm.wid },
        function (result) {
          //得到所有数据
          vm.detailInfo = result;
          if (result && result.workerCaseList) {
            vm.workerCaseList = result.workerCaseList;
          }

          if (result && result.worksList) {
            vm.workerCaseList = vm.workerCaseList.concat(result.worksList);
          }
          if (result && result.productionList) {
            vm.productionList = result.productionList;
          }
          document.title = vm.detailInfo.name + "的找我婚礼主页";
          vm.isloading = false;
        },
        function (result) {
          //alert(result.rdesc);
          vm.isloading = false;
        },
        function () {
          vm.isloading = false;
        }
      );
    },
    formateData: function (ctime, type) {
      return ctime ? dayjs(new Date(ctime)).format(type) : ctime;
    },
    setTouch: function () {
      let vm = this;
      let url = api.API_URL + "worker/v1/update/touch";
      vm.getNewAjax(
        url,
        { workerId: vm.wid },
        function (result) {},
        function (result) {},
        function () {}
      );
    },
  },
  mounted: function () {
    //记录浏览量
    this.setTouch();
  },
};
</script>
<style>
@import "../../assets/css/base.css";
@import "../../assets/css/shop.css";
</style>



// WEBPACK FOOTER //
// detail.vue?35994e0d